import React, { useEffect, useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import Loader from "../../Shared/Loader/Loader";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { GoogleMap, LoadScript, Marker, Autocomplete } from "@react-google-maps/api";
import { FloatLabel } from 'primereact/floatlabel';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "leaflet/dist/leaflet.css";
import APIConstant from "../../../utils/pathConstants";
import { useCatchResponse } from '../../../utils/useCatchResponse';

const containerStyle = {
    width: "100%",
    height: "280px",
};

const defaultCenter = {
    lat: 23.219537206,
    lng: 70.319537206,
};

const AddUpdateStopMaster = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [stopName, setStopName] = useState("");
    const [stopNameErr, setStopNameErr] = useState(false);
    const [stopNameErrText, setStopNameErrText] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [latitudeErr, setLatitudeErr] = useState(false);
    const [latitudeErrText, setLatitudeErrText] = useState("");
    const [longitudeErr, setLongitudeErr] = useState(false);
    const [longitudeErrText, setLongitudeErrText] = useState("");
    const [route, setRoute] = useState("");
    const [selectedCoordinates, setSelectedCoordinates] = useState(defaultCenter);
    const [mapRef, setMapRef] = useState(null);
    const autocompleteRef = useRef(null);

    const submitButtonRef = useRef(null);
    const stopNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        // Ensure focus after modal renders
        setTimeout(() => {
            stopNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setStopName(props?.masterData?.StopName);
            setLatitude(props?.masterData?.Latitude);
            setLongitude(props?.masterData?.Longitude);
            setSelectedCoordinates({
                lat: parseFloat(props?.masterData?.Latitude),
                lng: parseFloat(props?.masterData?.Longitude),
            });
        } else {
            handleCurrentLocation();
        }
    }, []);

    const handleCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const newCoords = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    setLatitude(position.coords.latitude.toString());
                    setLongitude(position.coords.longitude.toString());
                    setSelectedCoordinates(newCoords);
                    mapRef?.panTo(newCoords);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    Toast.error({ message: "Location access denied" });
                }
            );
        } else {
            Toast.error({ message: "Geolocation is not supported by this browser." });
        }
    };

    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setLatitude(lat.toString());
        setLongitude(lng.toString());
        setSelectedCoordinates({ lat, lng });
    };

    const handlePlaceSelect = () => {
        const place = autocompleteRef.current.getPlace();
        if (place.geometry) {
            const newCoords = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            setLatitude(newCoords.lat.toString());
            setLongitude(newCoords.lng.toString());
            setSelectedCoordinates(newCoords);
            mapRef.panTo(newCoords);
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*.\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        if (type === 'StopName') {
            setStopName(value);
        } else if (type === 'Latitude') {
            setLatitude(alphanumericValue);
        } else if (type === 'Longitude') {
            setLongitude(alphanumericValue);
        }
    };

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(stopName)) {
            formIsValid = false;
            setStopNameErr(true);
            setStopNameErrText("Stop Name is required");
        } else {
            setStopNameErr(false);
            setStopNameErrText("");
        }
        if (CommonConfig.isEmpty(latitude)) {
            formIsValid = false;
            setLatitudeErr(true);
            setLatitudeErrText("Latitude is required");
        } else {
            setLatitudeErr(false);
            setLatitudeErrText("");
        }
        if (CommonConfig.isEmpty(longitude)) {
            formIsValid = false;
            setLongitudeErr(true);
            setLongitudeErrText("Longitude is required");
        } else {
            setLongitudeErr(false);
            setLongitudeErrText("");
        }
        if (longitude == latitude) {
            formIsValid = false;
            setLongitudeErr(true);
            setLongitudeErrText("Longitude and Latitude can not be same");
        } else {
            setLongitudeErr(false);
            setLongitudeErrText("");
        }
        return formIsValid;
    };

    const handleSubmit = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    StopName: stopName.trim().replace(/\s+/g, ' '),
                    Latitude: latitude,
                    Longitude: longitude,
                    RouteName: route,
                    CreatedBy: securityUserID,
                };

                await api
                    .post(APIConstant.path.AddUpdateStopMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const onCancel = () => {
        props.onCancel();
        setStopName('');
        setLatitude('');
        setLongitude();
        setRoute('');
    }

    return (
        <div>
            <div className='p-grid'>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <label htmlFor="stopName">Stop<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                ref={stopNameRef}
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="stop"
                                type="text"
                                maxLength={200}
                                placeholder="Stop"
                                value={stopName}
                                autoFocus={true}
                                onChange={(e) => handleChange(e, 'StopName')}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {stopNameErr ? stopNameErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <label htmlFor="latitude">Latitude<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="latitude"
                                maxLength={20}
                                placeholder="Latitude"
                                value={latitude}
                                autoFocus={true}
                                onChange={(e) => handleChange(e, 'Latitude')}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {latitudeErr ? latitudeErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <label htmlFor="longitude">Longitude<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="longitude"
                                maxLength={20}
                                placeholder="Longitude"
                                value={longitude}
                                autoFocus={true}
                                onChange={(e) => handleChange(e, 'Longitude')}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {longitudeErr ? longitudeErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <div
                        style={{
                            width: "100%",
                            border: "1px solid #ccc",
                            borderRadius: "3px",
                        }}
                    >
                        <LoadScript
                            googleMapsApiKey={APIConstant.path.GoogleMapApiKey}
                            libraries={["places"]}
                        >
                            <div className='p-grid' style={{ position: "relative" }}>
                                <Autocomplete
                                    onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                                    onPlaceChanged={handlePlaceSelect}
                                    options={{
                                        fields: ["geometry", "name", "formatted_address"],
                                    }}
                                >
                                    <div className="p-pt-2 p-pl-2 custom-inputs">
                                        <InputText
                                            className="p-w-100"
                                            placeholder="Search location..."
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                marginBottom: "10px",
                                                borderRadius: "5px",
                                                border: "1px solid #ccc",
                                                position: "relative",
                                                zIndex: 10001,
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab' && !e.shiftKey) {
                                                    e.preventDefault();
                                                    if (submitButtonRef.current) {
                                                        submitButtonRef.current.focus();
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </Autocomplete>
                                <Button
                                    icon="pi pi-map-marker"
                                    className="e-btn p-mr-0 p-mt-2 p-ml-2"
                                    onClick={handleCurrentLocation}
                                />
                            </div>

                            <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={selectedCoordinates}
                                zoom={10}
                                onClick={handleMapClick}
                                onLoad={(map) => setMapRef(map)}
                            >
                                <Marker position={selectedCoordinates} />
                            </GoogleMap>
                        </LoadScript>
                    </div>
                </div>
            </div>

            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button className='btn-text-action-secondary' onClick={(e) => onCancel()}> cancel </Button>
                <Button ref={submitButtonRef} className='btn-text-action-primary submit-focus' label="Save" severity="secondary" raised onClick={(e) => handleSubmit()} />
            </div>
        </div>
    );
};

export default AddUpdateStopMaster;
